import Vue from 'vue';
import { MUTATION_TYPES } from '../../lib/mutationTypes';
export default Vue.extend({
    name: "Calculator",
    data() {
        return {
            input: "",
            values: [
                '', '→', 'CE', '=',
                '7', '8', '9', '÷',
                '4', '5', '6', '×',
                '1', '2', '3', '+',
                '.', '0', '⌫', '-',
            ],
            calculated: true,
            styles: {
                number: {
                    fontSize: 'x-large',
                    textAlign: 'center',
                    display: 'block',
                    padding: '8px',
                },
                operator: {
                    fontSize: 'x-large',
                    textAlign: 'center',
                    display: 'block',
                    color: 'white',
                    padding: '8px',
                }
            },
            showSuccess: false,
            canGo: true
        };
    },
    props: {
        to: {
            type: String,
            default: ''
        }
    },
    methods: {
        onTouched(value) {
            if (this.calculated) {
                this.$store.commit(MUTATION_TYPES.CLEAR_CALCULATOR_FORMULA);
                this.calculated = false;
            }
            if (value === 'CE') {
                // clear
                this.$store.commit(MUTATION_TYPES.CLEAR_CALCULATOR_FORMULA);
            }
            else if (value === '=') {
                // calculate formula
                const formula = this.$store.state.calculatorFormula.split('×').join('*').split('÷').join('/');
                try {
                    const value = eval(formula);
                    this.$store.commit(MUTATION_TYPES.SET_CALCULATOR_FORMULA, value.toString());
                    // to clear on next tap
                    this.calculated = true;
                }
                catch (_a) {
                }
            }
            else if (value === '⌫') {
                // back space
                this.$store.commit(MUTATION_TYPES.DROP_CALCULATOR_FORMULA);
            }
            else {
                // append to formula
                this.$store.commit(MUTATION_TYPES.APPEND_CALCULATOR_FORMULA, value);
            }
            const calculated = Number(this.$store.state.calculatorFormula);
            if (isFinite(calculated)) {
                this.$store.commit(MUTATION_TYPES.SET_CALCULATOR_VALUE, calculated);
                this.canGo = true;
            }
            else {
                this.canGo = false;
            }
        }
    },
    mounted() {
        this.$store.commit(MUTATION_TYPES.CLEAR_CALCULATOR_FORMULA);
        this.$store.commit(MUTATION_TYPES.SET_CALCULATOR_VALUE, 0);
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/Calculator.vue
// module id = 648
// module chunks = 1